import { intl } from "LocaleWrapper";
import { CustomDialog } from "components/dialogs/Dialogs";
import ContractDetails from "../../ContractDetails";
import { Button } from "@cofano/cck";
import useLinkContract from "view/contractsNew/utils/useLinkContract";
import { Contract, Charter } from "types/index";
import { PurchaseCharterFromQuery } from "view/charters/PurchaseCharterDetails";
import { useTheme } from "@mui/material";

const ContractDetailsDialog = ({ open, onClose, contract, charter, refetch }: {
    open: boolean,
    onClose: () => void,
	contract?: Pick<Contract, "id" | "charterSubtype">;
	charter?: Charter | PurchaseCharterFromQuery;
	refetch: () => void;
}) => {

	const theme = useTheme();

	const handleOnClose = () => {
		onClose();
	};

	const { linkContract, loading } = useLinkContract({
		onLink: () => refetch(),
	});

	return (
		<CustomDialog
			open={open}
			onClose={handleOnClose}
			title={intl.formatMessage({ id: "CONTRACT" })}
			dialogStyling={{ content: { backgroundColor: theme.palette.mode === "dark" ? "inherit" : "#EEE", padding: 0 } }}
			maxWidth="lg"
			actions={contract && charter && (
				<Button
					onClick={() => linkContract(contract, charter)}
					loading={loading}
					size="small">
					{intl.formatMessage({ id: "LINK" })}
				</Button>
			)}>
			<div style={{ padding: "16px 24px" }}>
				<ContractDetails
					pageInDialogSettings={{
						entityId: contract?.id,
					}} />
			</div>
		</CustomDialog>
	);
};

export default ContractDetailsDialog;
